import create from "zustand"

const useStore = create(set => ({
  logo: {},
  colors: {},
  navbar: [],
  sidebarExpand: false,
  setSidebarExpand: () =>
    set(state => ({ sidebarExpand: !state.sidebarExpand })),
  clearNavbar: () => set({ navbar: [] }),
}))

export default useStore
